import { FC, useState } from "react";
import styles from "./StockFundamentals.module.scss";


interface PropsTypes {
    obfuscated: boolean;
    fetchChartData: any;
    showRowOnChart: any;
    setShowRowOnChart: any;
    cell: any;
    setIsExpanded: (isExpanded: boolean) => void;
}
const ShowOnChart: FC<PropsTypes> = ({ obfuscated, fetchChartData, showRowOnChart, setShowRowOnChart, cell, setIsExpanded }) => {

    const [show, setShort] = useState<"Hide" | "Show">(showRowOnChart[cell.row.values.summary] || "Show");

    return (
        <button
            className={styles["chart-button"]}
            onClick={
                obfuscated
                    ? undefined
                    : () => {
                        fetchChartData(cell.row.index);
                        setShowRowOnChart({ ...showRowOnChart, [cell.row.values.summary]: showRowOnChart[cell.row.values.summary] === "Show" ? "Hide" : "Show" });
                        setIsExpanded(true);
                        setShort((prev) => prev === "Hide" ? "Show" : "Hide");
                    }
            }
        >
            {show}
        </button>
    );
};

export default ShowOnChart;